import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataTableService } from 'src/app/service/data-table.service';
import { DataTableFilter, FilterType } from '../datatable/datatable.component';

@Component({
    selector: 'app-dataviewfilter',
    templateUrl: './dataviewfilter.component.html',
    styleUrls: ['./dataviewfilter.component.css'],
    standalone: false
})
export class DataviewfilterComponent implements OnInit {

  FilterType = FilterType;
  @Input() filters: DataTableFilter[];

  resetOptionsSubscription: Subscription;

  dataFilterForm = new FormGroup({
  });

  constructor(public dataTableSrv: DataTableService) { }

  ngOnInit(): void {
    if (this.filters !== undefined) {
      this.filters.forEach(control => {
        this.dataFilterForm.addControl(control.name, new FormControl('', {
          updateOn: 'change'
        }));
      });
    }

    this.resetOptionsSubscription = this.dataTableSrv.resetFilterOptions$.subscribe((filter: DataTableFilter) => {
      let filterToUpdate: DataTableFilter = this.getFilter(filter);
      filterToUpdate.selected = filterToUpdate.values[0].value;
    });
  }

  ngOnDestroy(): void{
    this.resetOptionsSubscription.unsubscribe();
  }

  onApply(): void {
    this.dataTableSrv.onApplyFilter(this.filters);
  }

  onCancel(): void {
    this.dataFilterForm.reset();
    this.dataTableSrv.onCancelFilter();
  }

  getFilter(filterCtrl: DataTableFilter): DataTableFilter{
    let filter: DataTableFilter;
    for (let i = 0; i < this.filters.length; i++) {
      if (this.filters[i].name === filterCtrl.name) {
        filter = this.filters[i];
        break;
      }
    }

    return filter;
  }

  setCtrlValue(event: any, filterCtrl: DataTableFilter) {
    let filterToUpdate: DataTableFilter = this.getFilter(filterCtrl);
    filterToUpdate.selected = event.target.value;
    this.dataTableSrv.onFilterValueChanged(filterCtrl);
  }
}
